import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { useService } from '../../../services/services';
import { useEffect, useState } from 'react';
import { TableColumn } from './table';

export interface TableColumnConfigurationProps {
  field: string;
  id: string;
  translation_key: string;
  is_default?: boolean;
}

function useColumn<T>({
  config,
  columns,
}: {
  config: string;
  columns?: TableColumn<T>[];
}) {
  const [columnConfiguration, setColumnConfiguration] = useState([]);

  const { t } = useTranslation();
  const { userService } = useService();

  const { userState } = useSelector((state: RootState) => ({
    userState: state.global.user,
  }));

  const configuration: TableColumnConfigurationProps[] =
    userState.table_column_configuration?.[config] ||
    columnConfiguration.filter(
      (tableColumnConfiguration) => tableColumnConfiguration.is_default
    );

  useEffect(() => {
    const subscription = userService
      .tableConfigurations(config)
      .subscribe((values: TableColumnConfigurationProps[]) => {
        setColumnConfiguration(values);
      });

    return () => subscription.unsubscribe();
  }, [config, userService]);

  if (config && userState.table_column_configuration?.[config]) {
    columns = userState.table_column_configuration?.[config].map(
      (tableColumnConfiguration: TableColumnConfigurationProps) => {
        return {
          accessor: tableColumnConfiguration.field,
          header: t(tableColumnConfiguration.translation_key),
          sortable: true,
        };
      }
    ) as TableColumn<T>[];
  } else if (!columns) {
    columns = columnConfiguration
      .map((tableColumnConfiguration: TableColumnConfigurationProps) => {
        if (tableColumnConfiguration.is_default) {
          return {
            accessor: tableColumnConfiguration.field,
            header: t(tableColumnConfiguration.translation_key),
            sortable: true,
          };
        }

        return 0;
      })
      .filter((tableColumn) => tableColumn) as TableColumn<T>[];
  }

  return { columns, columnConfiguration: configuration };
}

export default useColumn;
